import { Box, Typography } from "@mui/material";
import { ReactElement, ReactNode } from "react";

import { FlexBox } from "../FlexBox";
import { DownloadDataButton } from "./DownloadDataButton";

export function AnalyticsDashboardSection<
  DownloadableRow extends Record<string, string>,
>({
  title,
  downloadDisabled,
  downloadableRows,
  downloadFileName,
  children,
}: {
  title: ReactNode;
  downloadDisabled?: boolean;
  downloadableRows?: DownloadableRow[];
  downloadFileName?: string;
  children: ReactNode;
}): ReactElement {
  return (
    <Box sx={{ width: "100%" }}>
      <FlexBox
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginBottom: "16px" }}
      >
        <Typography variant="h1Bold">{title}</Typography>
        {downloadableRows?.length ? (
          <DownloadDataButton
            disabled={downloadDisabled}
            downloadableRows={
              downloadableRows as [DownloadableRow, ...DownloadableRow[]]
            }
            fileName={downloadFileName ?? "data.csv"}
          />
        ) : null}
      </FlexBox>
      {children}
    </Box>
  );
}
